import { Link } from '@remix-run/react'
import logoUrl from '#app/routes/_marketing+/logos/momentumlogo.png'

export function MarketingFooter() {
	return (
		<footer className="border-t border-m-rule bg-ink text-ink-fg">
			<div className="mx-auto grid w-full max-w-5xl gap-12 px-6 py-16 md:grid-cols-3 md:px-10">
				<div>
					<Link to="/" className="flex items-center gap-2">
						<img src={logoUrl} alt="" className="h-7 w-7" />
						<span className="font-display text-base font-semibold">
							Momentum
						</span>
					</Link>
					<p className="mt-3 max-w-xs text-sm text-ink-fg-soft">
						Built for athletes and their coaches. Shared language.
					</p>
				</div>

				<div>
					<p className="text-eyebrow text-ink-fg-soft">Product</p>
					<ul className="mt-4 space-y-2 text-sm">
						<li>
							<Link to="/about" className="text-ink-fg-soft hover:text-ink-fg">
								About
							</Link>
						</li>
						<li>
							<Link to="/how-to" className="text-ink-fg-soft hover:text-ink-fg">
								How-to
							</Link>
						</li>
						<li>
							<Link
								to="/reference"
								className="text-ink-fg-soft hover:text-ink-fg"
							>
								Language Reference
							</Link>
						</li>
						<li>
							<Link to="/coach" className="text-ink-fg-soft hover:text-ink-fg">
								For Coaches
							</Link>
						</li>
					</ul>
				</div>

				<div>
					<p className="text-eyebrow text-ink-fg-soft">Legal</p>
					<ul className="mt-4 space-y-2 text-sm">
						<li>
							<Link
								to="/privacy"
								className="text-ink-fg-soft hover:text-ink-fg"
							>
								Privacy
							</Link>
						</li>
						<li>
							<Link to="/tos" className="text-ink-fg-soft hover:text-ink-fg">
								Terms
							</Link>
						</li>
						<li>
							<Link
								to="/support"
								className="text-ink-fg-soft hover:text-ink-fg"
							>
								Support
							</Link>
						</li>
					</ul>
				</div>
			</div>

			<div className="border-t border-m-rule">
				<div className="mx-auto flex w-full max-w-5xl items-center justify-between px-6 py-6 text-xs text-ink-fg-soft md:px-10">
					<p>© {new Date().getFullYear()} Momentum</p>
					<a href="mailto:hello@momentum.fitness" className="hover:text-ink-fg">
						hello@momentum.fitness
					</a>
				</div>
			</div>
		</footer>
	)
}
